import React from "react";

const Tabs = ({ activeTab, setActiveTab }) => {
  const tabs = ["Received", "Sent", "Approval Rules"];
  return (
    <div className="flex border-b">
      {tabs.map((tab, index) => (
        <button
          key={index}
          onClick={() => setActiveTab(tab)}
          className={`px-4 py-2 ${
            activeTab === tab
              ? "border-b-2 border-blue-500 text-blue-500"
              : "text-gray-500"
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
